import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-bell",
  templateUrl: "./bell.component.html",
  styleUrls: ["./bell.component.scss"],
})
export class BellComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
